import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const Whatwedo = () => {
    const navigate = useNavigate();

    return (
        <section className="bg-[#e9e9e9] w-full">

            {/* 4K SAFE CONTAINER */}
            <div className="max-w-[1600px] 2xl:max-w-[1800px] mx-auto">

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">

                    {/* LEFT */}
                    {/* <div className="p-6 sm:p-10 lg:p-14 xl:p-16 flex items-center">
                        <h1 className="
                            font-bold leading-[1.05]
                            text-4xl sm:text-7xl md:text-7xl lg:text-8xl xl:text-10xl
                        ">
                            What <br /> We <br /> do
                            <span className="text-[#f99728]">?</span>
                        </h1>
                    </div> */}
                    <div className="p-6 sm:p-10 lg:p-14 xl:p-16 flex items-center">
                        <h1
                            className="
      font-bold leading-[1.05]
      text-4xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl
      whitespace-nowrap sm:whitespace-normal
    "
                        >
                            <span className="inline sm:block">What</span>{" "}
                            <span className="inline sm:block">We</span>{" "}
                            <span className="inline sm:block">
                                do<span className="text-[#f99728]">?</span>
                            </span>
                        </h1>
                    </div>

                    {/* MIDDLE */}
                    <div className="p-6 sm:p-10 lg:p-14 xl:p-16 border-t md:border-t-0 md:border-l border-gray-300">

                        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-3">
                            Digital.
                        </h2>

                        <div className="w-12 h-1 bg-[#f99728] mb-6"></div>

                        <p className="text-base sm:text-lg mb-4 text-gray-700 italic font-serif">
                            We create super-rich experiences online!
                        </p>

                        <p className="text-gray-600 mb-6 leading-relaxed text-sm sm:text-base">
                            Growth Loom Digital is a results-driven digital marketing and web development agency dedicated to helping businesses grow online. We specialize in creating impactful strategies, user-friendly websites, and performance-focused campaigns. Our goal is to enhance your online presence, generate quality leads, and deliver measurable results that drive long-term business success.
                        </p>

                        <button
                            onClick={() => navigate("/About")}
                            className="flex items-center gap-2 font-bold text-base sm:text-lg group transition hover:text-[#f99728]"
                        >
                            ABOUT US
                            <span className="text-[#f99728] group-hover:translate-x-2 transition">
                                <FiArrowRight />
                            </span>
                        </button>
                    </div>

                    {/* RIGHT */}
                    <div className="p-6 sm:p-10 lg:p-14 xl:p-16 border-t lg:border-t-0 lg:border-l border-gray-300">

                        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-3">
                            And More Digital.
                        </h2>

                        <div className="w-12 h-1 bg-[#f99728] mb-6"></div>

                        <p className="italic text-base sm:text-lg mb-4 text-gray-700 font-serif">
                            Marketing brands with care
                        </p>

                        <p className="text-gray-600 mb-6 leading-relaxed text-sm sm:text-base">
                            What is marketing if it is not performance driven? We create digital experiences which stick with audiences and also reach the end objective. We focus on delivering measurable results that help your brand grow consistently in a competitive market. We combine strategy, creativity, analytics, and long-term brand impact effectively.
                        </p>

                        <button
                            onClick={() => navigate("/Services")}
                            className="flex items-center gap-2 font-bold text-base sm:text-lg group transition hover:text-[#f99728]"
                        >
                            OUR SERVICES
                            <span className="text-[#f99728] group-hover:translate-x-2 transition">
                                <FiArrowRight />
                            </span>
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Whatwedo;